import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
import MasterLayout from "../masterLayout/MasterLayout";
import ".././components/CSS/Crm.css";
import {
  firebase_notification,
  pre_pay_payment,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import plan1 from "../Assets/plan1.png";
import plan2 from "../Assets/plan2.png";
import plan3 from "../Assets/plan3.png";
import electricIcon from "../Assets/electricIcon.svg";
import goodmarkImg from "../Assets/goodmarkImg.svg";
import { handleError } from "../CommonJquery/CommonJquery.js";
// import "../components/CSS/PricingPage.css"; // Verify this path

const Subscription = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("monthly");
  const [selectedCountry, setSelectedCountry] = useState("india");
  const [pricingPlansnew, setPricingPlansnew] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dateCount, setDateCount] = useState(0);

  const planImages = {
    "plan1.svg": plan1,
    "plan2.svg": plan2,
    "plan3.svg": plan3,
  };

  const detectUserCountry = async () => {
    try {
      const response = await fetch("https://ipapi.co/json/");
      const data = await response.json();
      const country = data.country_code === "IN" ? "india" : "usa";
      setSelectedCountry(country);
    } catch (error) {
      console.log(error);
    }
  };

  const master_data_get = async () => {
    try {
      const formdata = new FormData();
      formdata.append("clear_or_not", "0");
      const Response = await server_post_data(firebase_notification, formdata);
      const data = Response.message.split("~@~");
      const final_data = JSON.parse(data[1]);
      if (parseInt(data[0]) === 1) {
        handleError(final_data.message);
      } else {
        const selectedPlanAmount = parseFloat(
          retrieveData("price_amount_package"),
        );
        const formattedSelectedPlan =
          selectedPlanAmount % 1 === 0
            ? selectedPlanAmount.toFixed(0)
            : selectedPlanAmount.toFixed(2);

        const updatedPlans = final_data.price_data.map((plan) => {
          if (!plan.pricing) return plan;

          const pricingInfo = plan.pricing[selectedCountry]?.[activeTab];
          if (!pricingInfo) return plan;

          const strippedPrice = pricingInfo.price.replace(/[^0-9.]/g, "");
          const isSelected = strippedPrice === formattedSelectedPlan;

          const selectedplanTrail =
            final_data.total_business_list?.find(
              (item) => item.bus_id === retrieveData("final_bus_id"),
            )?.trail_or_no || null;

          return {
            ...plan,
            price: pricingInfo.price,
            id_add: pricingInfo.id_add,
            buttonText:
              selectedplanTrail === "1"
                ? isSelected
                  ? "Buy Now"
                  : "Upgrade Now"
                : isSelected
                  ? "Current Plan"
                  : "Upgrade Now",
            isSelected,
          };
        });
        setPricingPlansnew(updatedPlans);
        setDateCount(getDaysUntil(final_data.user_data.end_date));
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  console.log("Pricing Plan", pricingPlansnew);

  const getDaysUntil = (date_get) => {
    const today = new Date();
    const target = new Date(date_get);
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    const diffTime = target.getTime() - today.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const handlePayment = async (plan) => {
    setIsLoading(true);
    try {
      const fd_from = new FormData();
      fd_from.append("id_add", plan.id_add);
      fd_from.append("flag", "1");
      const Response = await server_post_data(pre_pay_payment, fd_from);
      const data = Response.message.split("~@~");
      setIsLoading(false);
      const final_data = JSON.parse(data[1]);
      if (parseInt(data[0]) === 1) {
        handleError(final_data.message);
      } else {
        window.location.href = final_data.message;
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const handleNavigate = () => {
    window.open("https://www.wowreviews.co/Home/contact_us", "_blank");
  };

  const handleClose = () => {
    if (dateCount > 0) {
      navigate(-1);
    }
  };

  useEffect(() => {
    detectUserCountry();
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      master_data_get();
    }
  }, [selectedCountry, activeTab]);

  return (
    <MasterLayout>
      <div
        className="pricing-page setupReviewHeight2"
        style={{ paddingBottom: "10px" }}
      >
        <div className="pricing-container">
          <div className="pricing-header">
            {dateCount > 0 && (
              <div
                className="d-flex gap-1 align-items-center"
                style={{ justifyContent: "center" }}
              >
                <img
                  style={{ width: "20px" }}
                  src={electricIcon}
                  alt="electricIcon"
                />
                <p>Pricing Plans</p>
              </div>
            )}

            <div className="expired-message d-flex align-items-center justify-content-center">
              <AlertTriangle color="#d8000c" size={38} />
              <h4 style={{ marginTop: "8px" }}>
                Your Plan has Expired. Please Upgrade to Continue
              </h4>
            </div>

            <div className="tabs">
              <button
                className={`tabButton ${
                  activeTab === "monthly" ? "active" : ""
                }`}
                onClick={() => setActiveTab("monthly")}
              >
                Monthly
              </button>
              <button
                className={`tabButton ${
                  activeTab === "yearly" ? "active" : ""
                }`}
                onClick={() => setActiveTab("yearly")}
              >
                Annual <span className="freeText">(2 Month Free)</span>
              </button>
            </div>
          </div>
          <div className="row margnClass">
            {pricingPlansnew.map((plan, index) => (
              <div className="col-lg-4 col-md-6 col-sm-6 mt-3" key={index}>
                <div
                  className={`DataprinceBox1 ${
                    plan.isSelected ? "selected" : ""
                  }`}
                >
                  <img
                    src={planImages[plan.imgSrc] || "/placeholder.svg"}
                    alt={`Plan ${index + 1}`}
                  />
                  <h3>{plan.title}</h3>
                  <p>{plan.description}</p>
                  {plan.price && (
                    <h1>
                      {plan.price}
                      <span style={{ fontSize: "14px", color: "gray" }}>
                        /month{" "}
                        {selectedCountry === "india"
                          ? "(Including GST)"
                          : "(Excl. Tax)"}
                      </span>
                    </h1>
                  )}
                  {activeTab === "yearly" && index !== 2 && (
                    <p className="billedText">Billed Annually</p>
                  )}
                  <div className="amount">
                    <button
                      className={plan.id_add === "0@@@0" ? "margin_55_top" : ""}
                      disabled={plan.buttonText === "Current Plan"}
                      onClick={() =>
                        plan.id_add !== "0@@@0"
                          ? handlePayment(plan)
                          : handleNavigate()
                      }
                    >
                      {plan.buttonText}
                    </button>
                  </div>
                  <ul>
                    {plan.features.map((feature, featureIndex) => (
                      <div className="d-flex margnLabal" key={featureIndex}>
                        <img
                          src={goodmarkImg || "placeholder.svg"}
                          alt="Goodmark"
                          className="GreenMarkImng"
                        />
                        <label>
                          <strong>{feature.text}</strong>{" "}
                          {feature.additionalText}
                        </label>
                      </div>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default Subscription;
